import { render, staticRenderFns } from "./DialogComponent.vue?vue&type=template&id=1dbc80de&scoped=true&lang=pug"
import script from "./DialogComponent.vue?vue&type=script&lang=ts"
export * from "./DialogComponent.vue?vue&type=script&lang=ts"
import style0 from "./DialogComponent.vue?vue&type=style&index=0&id=1dbc80de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbc80de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dbc80de')) {
      api.createRecord('1dbc80de', component.options)
    } else {
      api.reload('1dbc80de', component.options)
    }
    module.hot.accept("./DialogComponent.vue?vue&type=template&id=1dbc80de&scoped=true&lang=pug", function () {
      api.rerender('1dbc80de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/DialogComponent.vue"
export default component.exports